import {get} from './api'

export default {
    updateUser(params) {
        const config = params.auth ? 'Auth' : 'Status'
        const url = '/updateUser' + config
        return get(url, params)
    },
    getUserIDs(token) {
        return get('/getUserIDs', {token})
    },
    getUserStatByID(params) {
        return get('/getUserStatByID', params)
    }
}
